import { render, staticRenderFns } from "./popup-friend.vue?vue&type=template&id=fec9727e&scoped=true&"
import script from "./popup-friend.vue?vue&type=script&lang=js&"
export * from "./popup-friend.vue?vue&type=script&lang=js&"
import style0 from "./popup-friend.vue?vue&type=style&index=0&id=fec9727e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec9727e",
  null
  
)

export default component.exports